import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeReportSmallComponent = (function () {
    function CasePracticeReportSmallComponent(route, router, apiService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.onStartNextCase = new EventEmitter();
        this.onSwitchReport = new EventEmitter();
        this.onExit = new EventEmitter();
    }
    CasePracticeReportSmallComponent.prototype.ngOnInit = function () {
        this.sentence = "不深入了解病因的辅导，犹如隔靴搔痒";
        this.expert_title = "（DDI全球副总裁）";
        this.expert_content = "不深入了解病因的辅导，犹如隔靴搔痒";
    };
    CasePracticeReportSmallComponent.prototype.ngAfterViewInit = function () {
        var html = document.documentElement;
        var htmlFontSize = html.clientWidth / 7.5;
        html.style.fontSize = htmlFontSize + "px";
        html.style.backgroundColor = "#3d3d6e";
        var smallReportAnswer = document.getElementById("smallReportAnswer");
        var closeBtnReport = document.getElementById("closeBtnReport");
        var bodyHeight = document.body.offsetHeight;
        smallReportAnswer.style.height = bodyHeight * 0.8 + 'px';
        smallReportAnswer.style.marginTop = bodyHeight * 0.06 + 'px';
        closeBtnReport.style.top = bodyHeight * 1.88 + 'px';
        this.enableRolling();
    };
    CasePracticeReportSmallComponent.prototype.onDetailBtnClick = function () {
        var smallReportAnswer = document.getElementById("smallReportAnswer");
        var closeBtnReport = document.getElementById("closeBtnReport");
        var bodyHeight = document.body.offsetHeight;
        this.scrollTop = document.body.scrollTop | document.documentElement.scrollTop;
        $("#shade").fadeIn(500);
        smallReportAnswer.style.top = "0rem";
        closeBtnReport.style.top = bodyHeight * 0.88 + 'px';
        this.disableRolling();
        $("#wrap").addClass("fixed");
        $("#wrap").css({ top: -this.scrollTop });
    };
    CasePracticeReportSmallComponent.prototype.onCloseBtnReportClick = function () {
        var smallReportAnswer = document.getElementById("smallReportAnswer");
        var closeBtnReport = document.getElementById("closeBtnReport");
        $("#shade").fadeOut(500);
        smallReportAnswer.style.top = "15.34rem";
        closeBtnReport.style.top = "25.76rem";
        this.enableRolling();
        $("#wrap").removeClass("fixed");
        document.documentElement.scrollTop = this.scrollTop;
    };
    CasePracticeReportSmallComponent.prototype.redo = function () {
        var _this = this;
        this.apiService.resetQuiz(this.report.reports[this.currentIndex].id).subscribe(function (result) {
            var practiceId = result.practiceId;
            var learningPathId = result.learningPathId;
            var practiceMetaId = result.practiceMetaId;
            var link = [];
            if (learningPathId > 0) {
                link = ['case-practice', learningPathId, practiceId];
            }
            else {
                link = [practiceMetaId, 'case-practice'];
            }
            _this.router.navigate(link);
        });
    };
    CasePracticeReportSmallComponent.prototype.startNextCase = function () {
        this.onStartNextCase.emit(true);
    };
    CasePracticeReportSmallComponent.prototype.close = function () {
        this.onExit.emit(true);
    };
    CasePracticeReportSmallComponent.prototype.switchReport = function (params) {
        this.onSwitchReport.emit(params);
    };
    CasePracticeReportSmallComponent.prototype.moveOut = function () {
        $('#reportWrap').animate({ left: '1000px' }, 500);
    };
    CasePracticeReportSmallComponent.prototype.moveIn = function () {
        $('#reportWrap').animate({ left: '0px' }, 500);
    };
    CasePracticeReportSmallComponent.prototype.disableRolling = function () {
        document.getElementById("shade").ontouchstart = function (e) {
            e.preventDefault();
        };
        document.getElementById("closeBtnReport").ontouchmove = function (e) {
            e.preventDefault();
        };
    };
    CasePracticeReportSmallComponent.prototype.enableRolling = function () {
        $("body").off("touchmove");
    };
    return CasePracticeReportSmallComponent;
}());
export { CasePracticeReportSmallComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-report-small/case-practice-report-small.component.ts.pre-build-optimizer.js